module.exports = __webpack_public_path__ + "assets/img/微信截图_20190926094653.50e396ac.png";